// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  cardId: __t.uuid().name("card_id"),
  interestDollarAmount: __t.i64().name("interest_dollar_amount"),
  firstName: __t.option(__t.string()).name("first_name"),
  lastName: __t.option(__t.string()).name("last_name"),
  supportiveMessage: __t.option(__t.string()).name("supportive_message"),
  consentToDisplay: __t.bool().name("consent_to_display"),
});
